import { CompanyAuthenticationTabWebComponent } from './component/CompanyAuthenticationTabWebComponent';
import { WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB } from '../../../webcomponents.constants';

export { CompanyAuthenticationTabWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB, CompanyAuthenticationTabWebComponent);
